export const environment = {
    production: true,
    apiUrl: 'http://localhost:9000/v1/onpeople'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts